/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash e97fc2bf3140d3d8445dba602647600d */

import { ConcreteRequest } from "relay-runtime";

import {  } from "relay-runtime";
export type responsiveFooterClientQueryVariables = {
    userId?: string | null | undefined;
    hasUserId: boolean;
};
export type responsiveFooterClientQueryResponse = {
    readonly viewer: {
        readonly user?: {
            readonly " $fragmentRefs": FragmentRefs<"DisplaySettingsModal_user">;
        } | null | undefined;
        readonly " $fragmentRefs": FragmentRefs<"DisplaySettingsModal_viewer" | "FooterSubscribe_viewer">;
    };
};
export type responsiveFooterClientQuery = {
    readonly response: responsiveFooterClientQueryResponse;
    readonly variables: responsiveFooterClientQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasUserId"
    } as any, v1 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "userId"
    } as any, v2 = [
        {
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
        } as any
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "responsiveFooterClientQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "DisplaySettingsModal_viewer"
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "FooterSubscribe_viewer"
                        },
                        {
                            "condition": "hasUserId",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v2 /*: any*/),
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "DisplaySettingsModal_user"
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ]
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "RootQueryType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "responsiveFooterClientQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "currencies",
                            "storageKey": null
                        },
                        {
                            "alias": "intlMvpEnabled",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "feature",
                                    "value": "intlMVP2022"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "featureFlag",
                            "storageKey": "featureFlag(feature:\"intlMVP2022\")"
                        },
                        {
                            "alias": "isSegmentedIntlUrlsEnabled",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "feature",
                                    "value": "segmentedIntlUrls"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "featureFlag",
                            "storageKey": "featureFlag(feature:\"segmentedIntlUrls\")"
                        },
                        (v3 /*: any*/),
                        {
                            "condition": "hasUserId",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v2 /*: any*/),
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "serviceId",
                                            "storageKey": null
                                        },
                                        (v3 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Profile",
                                            "kind": "LinkedField",
                                            "name": "profile",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "currency",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ]
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "ferrum/352.0.0-2022-02-11T14:31:47.735Z/responsiveFooterClientQuery",
            "metadata": {},
            "name": "responsiveFooterClientQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '1a143b27ff0ff8602475dc452cb740f5';
export default node;
